module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/events-screen/white-board/white-board.component.scss
// module id = ./src/app/admin/events-screen/white-board/white-board.component.scss
// module chunks = main